import { Pipe, PipeTransform } from '@angular/core';

import { REPRESENTANTES_MODALIDES_COMERCIAIS } from '../../domain/representante-modalidade-comercial.enum';

@Pipe({
    name: 'representanteModalidadeComercial'
})
export class RepresentanteModalidadeComercialPipe implements PipeTransform {
    transform(value: number, field = 'nome'): string {
        if (!value) {
            return '';
        }

        const index = REPRESENTANTES_MODALIDES_COMERCIAIS.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return REPRESENTANTES_MODALIDES_COMERCIAIS[index][field];
        }
        return '';
    }
}
